import { render, staticRenderFns } from "./DxEffortTask.vue?vue&type=template&id=7de70cb1&"
import script from "./DxEffortTask.vue?vue&type=script&lang=js&"
export * from "./DxEffortTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports